<template>
  <div class="container page">
    <van-nav-bar :title="$t('setPayPassword.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
        <div class="item">
            <p class="title">{{ $t("setPayPassword.opw") }}</p>
            <van-password-input
                :value="opw"
                :length="4"
                :gutter="10"
                :focused="oshowKeyboard"
                @focus="oshowKeyboard = true;tshowKeyboard = false;"
            />
            <van-number-keyboard
                v-model="opw"
                :show="oshowKeyboard"
                @input ="opw.length !== 3 ? oshowKeyboard = true  : tshowKeyboard=true;"
                @blur="oshowKeyboard = false"
            />
        </div>
        <div class="item">
        <p class="title">{{ $t("setPayPassword.tpw") }}</p>
        <van-password-input
            :value="tpw"
            :length="4"
            :gutter="10"
            :focused="tshowKeyboard"
            @focus="tshowKeyboard = true;oshowKeyboard=false;"
        />
        <van-number-keyboard
            v-model="tpw"
            :show="tshowKeyboard"
            @input ="tpw.length !== 3 ? tshowKeyboard = true  : tshowKeyboard = false;oshowKeyboard=false"
            @blur="tshowKeyboard = false"
        />
      </div>
        <van-button class="sub-btn" type="default" @click="setPayPassword()">{{ $t("msg.提交") }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if(this.opw.length !== 4){
        this.oshowKeyboard = true;
        this.$toast(this.$t("msg.请填写完整"));
        return false;
      }
      if(this.tpw.length !== 4){
        this.tshowKeyboard = true;
        this.$toast(this.$t("msg.请填写完整"));
        return false;
      }
      if(this.opw !== this.tpw){
        this.$toast(this.$t("msg.两次密码不一致！"));
        return false;
      }else {
        this.$http({
          method: 'get',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        }).then(res=>{
          if(res.code === 200){
            setTimeout(() => {
              this.$toast(this.$t("msg."+res.msg));
            }, 500);
            if(this.$route.query.type == 1) {
              this.$router.push({path:'/BindCard'})
            }else{
              this.$router.push("Mine")
            }
          }else if(res.code ===401){
            this.$toast(this.$t("msg."+res.msg));
          }
        })
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 20PX 0;
  line-height: 20PX;
  font-size: 16PX;
  font-weight: 500;
  color: #000;
  text-align: center;
}
::v-deep .van-password-input{
  width: 80%;
  height: 75PX;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 16PX;
  line-height: 30;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 60PX;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 16PX;
}
.van-password-input__security i {
  width: 18PX;
  height: 18PX;
}
::v-deep .van-key {
  height: 50PX;
  font-size: 32PX;
  line-height: 20PX;
  border-radius: 20PX;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 16PX;
  background-color: #f2f3f5;
  margin: auto;
}
::v-deep .van-number-keyboard__body{
  width: 100%;
  max-width: 500PX;
  margin: auto;
}
::v-deep .van-key__collapse-icon {
   width: 50PX;
   height: 50PX;
 }
::v-deep .van-key__delete-icon {
  width: 50PX;
  height: 50PX;
}
.container .wrapper .sub-btn{
  width: 80%;
  margin: 20PX auto 0;
  height: 40PX;
  padding: .86667rem 0;
  border-radius: .13333rem;
  color: #fff;
  font-size: 16PX;
  font-weight: bolder;
  border: none;
  background: linear-gradient(-180deg,#fc78af,#f22678)
}
</style>
